import React, { useState } from 'react';
import { ThemeProvider } from './components/ThemeContext';
import { BottomNav } from './components/BottomNav';
import { ManagementScreen } from './components/ManagementScreen';
import { SubscriptionScreen } from './components/SubscriptionScreen';
import { OnboardingScreen } from './components/OnboardingScreen';
import { MambaLoginScreen } from './components/MambaLoginScreen';
import { CitySelectScreen } from './components/CitySelectScreen';
import { motion, AnimatePresence } from 'framer-motion';
type Tab = 'management' | 'subscription';
type AuthStage = 'onboarding' | 'login' | 'city' | 'app';
export function App() {
  const [activeTab, setActiveTab] = useState<Tab>('management');
  const [authStage, setAuthStage] = useState<AuthStage>('onboarding');
  const [city, setCity] = useState('Москва');
  const [email, setEmail] = useState('');
  const handleOnboardingComplete = () => setAuthStage('login');
  const handleLoginComplete = (login: string) => {
    setEmail(login);
    setAuthStage('city');
  };
  const handleCityComplete = () => setAuthStage('app');
  const handleLogout = () => setAuthStage('login');
  const handleChangeCity = () => setAuthStage('city');
  return <ThemeProvider data-id="element-0">
      <div className="min-h-screen bg-neutral-950 flex justify-center" data-id="element-1">
        <div className="w-full max-w-[500px] min-h-screen bg-svt-bg text-svt-text font-sans selection:bg-svt-pink selection:text-white transition-colors duration-300 relative shadow-2xl" data-id="element-2">
          <AnimatePresence mode="wait" data-id="element-3">
            {authStage === 'onboarding' && <motion.div key="onboarding" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.25
          }} data-id="element-4">
                <OnboardingScreen onComplete={handleOnboardingComplete} data-id="element-5" />
              </motion.div>}

            {authStage === 'login' && <motion.div key="login" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.25
          }} data-id="element-6">
                <MambaLoginScreen onComplete={handleLoginComplete} data-id="element-7" />
              </motion.div>}

            {authStage === 'city' && <motion.div key="city" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.25
          }} data-id="element-8">
                <CitySelectScreen onComplete={handleCityComplete} data-id="element-9" />
              </motion.div>}

            {authStage === 'app' && <motion.div key="app" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.25
          }} data-id="element-10">
                <div className="pb-20" data-id="element-11">
                  <AnimatePresence mode="wait" data-id="element-12">
                    {activeTab === 'management' && <motion.div key="management" initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: 20
                }} transition={{
                  duration: 0.2
                }} data-id="element-13">
                        <ManagementScreen city={city} email={email} onLogout={handleLogout} onChangeCity={handleChangeCity} data-id="element-14" />
                      </motion.div>}
                    {activeTab === 'subscription' && <motion.div key="subscription" initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: 20
                }} transition={{
                  duration: 0.2
                }} data-id="element-15">
                        <SubscriptionScreen data-id="element-16" />
                      </motion.div>}
                  </AnimatePresence>
                </div>
                <BottomNav activeTab={activeTab} onTabChange={setActiveTab} data-id="element-17" />
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </ThemeProvider>;
}